module.exports = __webpack_public_path__ + "img/icon-arrow-category-filter.9135e760.svg";